import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { ServiceAreas } from '../components/ServiceAreas';
import { Contact } from '../components/Contact';
export function Home() {
  return <>
      <Hero data-id="element-280" />
      <Services data-id="element-281" />
      <WhyChooseUs data-id="element-282" />
      <Process data-id="element-283" />
      <Testimonials data-id="element-284" />
      <ServiceAreas data-id="element-285" />
      <Contact data-id="element-286" />
    </>;
}